import { AUTH_TOKEN } from "constants/AuthConstant"
import fetch from "auth/FetchInterceptor"

const DocumentService = {}

DocumentService.getAllDocuments = function ({ query = "", page = 1 }) {
  let url = `/document/getAll?page=${page}&limit=10`
  if (query) {
    url += `&title=${query}`
  }
  return fetch({
    method: "get",
    url: url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

DocumentService.getDocumentsByClient = function (clientId) {
  return fetch({
    method: "get",
    url: `/document/client/${clientId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

DocumentService.getDocumentById = function (id) {
  return fetch({
    method: "get",
    url: `/document/getById/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

DocumentService.createDocument = function (clientId, data) {
  return fetch({
    method: "post",
    url: `/document/partner/create/${clientId}`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      "Content-Type": "multipart/form-data", // utile si vous envoyez un fichier
    },
  })
}

DocumentService.updateDocumentById = function (id, data) {
  return fetch({
    method: "put",
    url: `/document/partner/update/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      "Content-Type": "multipart/form-data",
    },
  })
}

DocumentService.deleteDocumentById = function (id) {
  return fetch({
    method: "delete",
    url: `/document/partner/delete/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  })
}

export default DocumentService
